import { useTranslation } from 'react-i18next'

import { MapPinIcon } from '@phosphor-icons/react'
import { useTheme } from 'styled-components'

import { Select } from '@reveni-io/reveni-ui'

const RegionsSelect = ({ onChange, value, regions = [] }) => {
  const theme = useTheme()
  const { t } = useTranslation()

  const options = [
    { label: t('Todos los países'), value: 'all' },
    ...regions.map(o => ({ label: o.name, value: o.id })),
  ]

  return (
    <Select
      icon={<MapPinIcon size={16} />}
      backgroundColor={theme.colors.background.secondary}
      onChange={onChange}
      value={value}
      options={options}
    />
  )
}

export default RegionsSelect
